
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind9 as ObiWind9Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-9.js';
 
 
 

 
 export const ObiWind9 = createComponent({
   react: React,
   tagName: 'obi-wind-9',
   elementClass: ObiWind9Element,
   events: {
     
   }
  });
 
 